//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibNextScreenTrigger',
  components: {
    FibStaffButton: require('@/components/FIBStaffButton').default
  },
  props: {
    disable: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    userCanSkip: {
      type: Boolean
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      if (this.loading || this.disable) {
        return;
      }

      this.$emit('click', e);
    },
    handleSkip: function handleSkip() {
      if (this.loading || this.disable) {
        return;
      }

      this.$emit('click', true);
    }
  }
};